import { MouseEventHandler } from 'react';
import { SC } from '../../styles/theme';
import { IconStyled } from './IconStyled';

export enum Icons {
    Search,
    ShoppingCart,
    Menu,
    Call,
    Book,
    Bezpecnost,
    Notification,
    Notice,
    FutureCourse,
    Recommendation,
    Record,
    File,
    Favourite,
    FavouriteFull,
    MyCourses,
    MyConferences,
    MyFavourites,
    MyMaterials,
    Danove,
    Mzdove,
    Profi,
    Sprava,
    Poradca,
    Success,
    Failed,
    Discount,
    Capacity1,
    Capacity2,
    Capacity3,
    Board,
    Zoom,
    Calendar,
    Feedback,
    Play,
    Wifi,
    Approve,
    Coffee,
    Aids,
    Facebook,
    Instagram,
    Linkedin,
    Twitter,
    Youtube,
    User,
    Message,
    Phone,
    Mail,
    CheckThin,
    Trash,
    Direction,
    Player,
    Previous,
    Next,
    Send,
    Point,
    PhoneMail,
    Settings,
    Diploma,
    Lesson,
    Student,
    ArrowDown,
    ArrowRight,
    Teacher,
    Laptop,
    MailOpen,
    Xmark,
    ChevronUp,
    ChevronDown,
    ArrowCircleRightActive,
    ArrowCircleLeftDisabled,
    ArrowCircleLeftActive,
    ArrowCircleRightDisabled,
}

export interface IconProps extends SC {
    width?: number;
    height?: number;
    name: Icons;
    color?: string;
    onClick?: MouseEventHandler<HTMLDivElement>;
}

export const Icon = IconStyled;
export default Icon;
